import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-list-images',
  templateUrl: './list-images.component.html',
  styleUrls: ['./list-images.component.css'],
})
export class ListImagesComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
